import ResumerBuilderLayout from "./ResumeBuilderLayout";

export default ResumerBuilderLayout;
